import React from "react";
import { ClockIcon } from "@phosphor-icons/react";
import { Tooltip } from "@mui/material";

/**
 * Visual marker for an AI-originated row that hasn't been reviewed yet.
 *
 * One component so there's exactly one place to change the icon,
 * tooltip copy, or color if the design evolves. Render it inline next
 * to whatever label the user identifies the pending thing by
 * (attribute name, document filename, interaction title, mention chip,
 * grid row name, etc.). Renders nothing when `staging` is false / undefined.
 */
export interface PendingReviewBadgeProps {
  staging: boolean | undefined;
  /** Override the default tooltip copy for more contextual phrasing. */
  tooltip?: string;
  /** Pixel size of the clock icon. Defaults to 12. */
  size?: number;
}

const DEFAULT_TOOLTIP = "Pending review — AI-written, not yet approved.";

const PendingReviewBadge: React.FC<PendingReviewBadgeProps> = ({
  staging,
  tooltip = DEFAULT_TOOLTIP,
  size = 12,
}) => {
  if (!staging) return null;
  return (
    <Tooltip title={tooltip} placement="top" arrow>
      {/* Named so a surface with its own review control (the interaction
          rail, #12298) can hide the per-item clock. */}
      <span
        data-pending-review=""
        className="inline-flex items-center align-middle text-[#1A3D4F]"
      >
        <ClockIcon size={size} />
      </span>
    </Tooltip>
  );
};

export default PendingReviewBadge;
